module.exports = __webpack_public_path__ + "img/beeIcon.6b53db5f.png";